
import React from 'react';

export default function Hero() {
  const handleBookingClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const bookingSection = document.getElementById('termin-buchen');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/40d3b560-fb8a-43a8-a511-dcc5e930f4fd_Foto-2-von-21.jpg?v=0cf56b189c78fc597a3e4dda4989aa68" 
          alt="Physiotherapie Background" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-white/5 to-white/15"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 border border-gold-300/20 rounded-full opacity-50"></div>
      <div className="absolute bottom-32 right-16 w-48 h-48 border border-gold-300/20 rounded-full opacity-30"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-32 text-center w-full">
        <div className="mb-6">
          <span className="inline-block text-gold-300 text-sm font-medium tracking-[0.3em] uppercase mb-4">
            Willkommen bei
          </span>
        </div>
        <h1 className="font-serif text-5xl md:text-7xl font-semibold text-white mb-6 leading-tight tracking-tight">
          Physiotherapie
          <span className="block text-gold-300 italic mt-2">Theresa Mühlbacher</span>
        </h1>
        <div className="w-24 h-px bg-gold-300/60 mx-auto mb-8"></div>
        <h2 className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed font-light">
          Zurück zu deiner alten Stärke. Ich begleite dich unkompliziert und schnell zurück in einen aktiven Alltag.
        </h2>
        <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
          <a 
            href="#termin-buchen" 
            onClick={handleBookingClick}
            className="bg-gold-300 text-olive-900 px-10 py-4 rounded-full text-base font-semibold hover:bg-gold-400 transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Jetzt Termin buchen
          </a>
          <a 
            href="#leistungen" 
            className="bg-transparent text-white px-10 py-4 rounded-full text-base font-medium hover:bg-white/10 transition-all duration-300 border border-white/40 cursor-pointer whitespace-nowrap"
          >
            Mehr erfahren
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-gold-300/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2.5 bg-gold-300/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
